module.exports = __webpack_public_path__ + "static/media/S-task12_adjMatrix.f17a7ce4.png";